module.exports = __webpack_public_path__ + "static/media/Call.37ff882f.svg";